import { toast } from 'react-toastify';

import React, { useCallback, useState, useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import * as NavigationUtils from '../../utils/navigation';

import { signature } from '../../processes/document';
import * as FileUtils from '../../utils/file.js';

import Document from './Document';
import Header from '../../components/Header';
import DocumentFooter from '../../components/DocumentFooter';
import SignatureModal from '../../components/SignatureModal';
import Container from '../../components/Container';

import { usePatientDocumentContext } from '../../contexts/PatientDocument';
import { useWindowDimensions } from '../../utils/windowDimensionSize';

function DocumentContainer() {
	const [loading, setLoading] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const history = useHistory();
	const { width } = useWindowDimensions();

	const { document, code } = usePatientDocumentContext();

	useEffect(() => {
		if (document && code) {
			return;
		}

		return NavigationUtils.navigate(history, `/?code=${code}`);
	}, [history, document, code]);

	const onClickSignatureBox = useCallback(() => {
		if (width < 600) {
			return NavigationUtils.navigate(history, `/signature?code=${code}`);
		}

		setIsModalOpen(true);
	}, [code, history, width]);

	const onCloseModal = useCallback(() => {
		setIsModalOpen(false);
	}, []);

	const submit = useCallback(async () => {
		const documentData = {
			id: document?.id,
			code,
			file: await FileUtils.getBase64Blob(document?.signature_url)
		};

		if (document.pass_code) {
			documentData.document_number = document.pass_code;
		}

		if (!documentData.file) {
			return toast.warn('A fim de concluir o processo, é necessário assinar o documento.');
		}

		setLoading(true);

		const { data, error } = await signature(documentData);

		setLoading(false);

		if (error) {
			toast.error('Não foi possível assinar o documento, tente novamente em alguns instantes.');
		} else {
			toast.success('Documento assinado com sucesso!');

			document.pdf_url = data?.url;

			NavigationUtils.navigate(history, `/signature-success?code=${code}`);
		}
	}, [code, document, history]);

    return (
		<Container style={{ minHeight: '100vh' }}>
			<Header />

			<Document
				loading={loading}
				document={document}
				onClickSignatureBox={onClickSignatureBox}
			/>

			<DocumentFooter
				loading={loading}
				disabled={!document?.signature_url}
				onClick={submit}
			>
				Assinar e concluir
			</DocumentFooter>

			{isModalOpen && (
				<SignatureModal onClose={onCloseModal} />
			)}
		</Container>
	);
}

export default DocumentContainer;
